import { ReactComponent as AmazonLogo } from '../../../../assets/images/AmazonWebservices.svg';
import { ReactComponent as OpenAILogo } from '../../../../assets/images/OpenAI_Logo.svg';
import { ReactComponent as NVIDIA_Logo } from '../../../../assets/images/Nvidia-Logo.svg';
import { ReactComponent as BackgroundImage } from '../../../../assets/images/signin_background.svg';
import { Stack, Typography, useTheme } from '@mui/material';
import React from 'react';

interface IIntroductionProps {
  tab: number;
}

const LOGOS = [AmazonLogo, OpenAILogo, NVIDIA_Logo];

const Introduction: React.FC<IIntroductionProps> = ({ tab }) => {
  const theme = useTheme();
  const isSingupForm = tab === 1;

  return (
    <>
      {isSingupForm && (
        <Stack
          sx={{
            flex: 1,
            padding: '115px 60px 0',
            background: theme.custom.palette.primary.default,
            color: '#fff',
            gap: '40px',
          }}
        >
          <Typography variant="h1">AI-копирайтер для создания текстов</Typography>

          <Stack>
            <Typography>Первый AI-копирайтер, который за несколько кликов помогает создавать текст для сайта, блога, социальных сетей и интернет-магазинов</Typography>
          </Stack>

          <Typography>Ведущие AI технологии на службе у вашего бизнеса</Typography>
          <Stack direction={'row'} gap={'20px'}>
            {LOGOS.map((Logo, idx) => (
              <Logo key={idx} style={{ width: 140, height: 120 }} />
            ))}
          </Stack>
          <Typography>...и даже больше</Typography>
        </Stack>
      )}

      {!isSingupForm && (
        <Stack sx={{ flex: 1, background: '#f6f8fb', paddingTop: '115px', alignItems: 'center' }}>
          <BackgroundImage />
        </Stack>
      )}
    </>
  );
};

export default Introduction;
